import { Schema } from "effect";
import { Resource } from "@brytdesigns/shopify-utils/effect";
import { parseFormData, parseSearchParams } from "../schema";

import { QuantityBase, PropertiesBase } from "./base";

const Quantity = QuantityBase.pipe(
  Schema.filter((value) => {
    if (value > 0) return true;
    return "Quantity must be a positive number. Please enter a valid quantity.";
  }),
  Schema.optionalWith({
    default: () => 1,
  }),
);

const Properties = PropertiesBase.pipe(Schema.optional);

const AddToCartSingleBase = Schema.Struct({
  id: Resource.ID,
  quantity: Quantity,
  selling_plan_id: Schema.optional(Resource.ID),
  properties: Properties,
});

const AddToCartManyBase = Schema.Struct({
  id: Schema.Array(Resource.ID),
  quantity: Schema.optional(Schema.Array(QuantityBase)),
  selling_plan_id: Schema.optional(Schema.Array(Resource.ID)),
  properties: Schema.optional(Schema.Array(PropertiesBase)),
}).pipe(
  Schema.transform(
    Schema.Array(
      Schema.Struct({
        id: Resource.ID,
        quantity: Quantity,
        selling_plan_id: Schema.optional(Resource.ID),
        properties: Properties,
      }),
    ),
    {
      strict: false,
      decode: (input) => {
        let items: any[] = [];
        for (let i = 0; i < input.id.length; i++) {
          const id = input.id[i];
          const quantity =
            input.quantity && input.quantity[i] ? input.quantity[i] : 1;
          const selling_plan_id =
            input.selling_plan_id && input.selling_plan_id[i]
              ? input.selling_plan_id[i]
              : undefined;
          const properties =
            input.properties && input.properties[i]
              ? input.properties[i]
              : undefined;
          items.push({ id, quantity, selling_plan_id, properties });
        }
        return items;
      },
      encode: (a) =>
        a.map((item) => Schema.encodeUnknownSync(AddToCartSingleSchema)(item)),
    },
  ),
);

export const AddToCartSingleSchema = AddToCartSingleBase;

export const AddToCartManySchema = AddToCartManyBase;

export const AddToCartSchema = Schema.Union(
  AddToCartManySchema,
  AddToCartSingleSchema,
).pipe(Schema.asSchema);

export const FormDataSchema = parseFormData(AddToCartSchema);

export const SearchParamsSchema = parseSearchParams(AddToCartSchema);

export const toFormData = (data: typeof AddToCartSchema.Type) =>
  Schema.encodeSync(FormDataSchema)(data);

export const fromFormData = (data: FormData) =>
  Schema.decodeSync(FormDataSchema)(data);

export const toSearchParams = (data: typeof AddToCartSchema.Type) =>
  Schema.encodeSync(SearchParamsSchema)(data);
export const fromSearchParams = (data: URLSearchParams) =>
  Schema.decodeSync(SearchParamsSchema)(data);
